<div
    class="tw-flex tw-flex-col md:tw-flex-row lg:tw-gap-[60px] md:tw-gap-[30px] tw-gap-[30px] tw-py-[50px] lg:tw-px-[140px] md:tw-px-[70px] tw-px-[28px] tw-items-stretch tw-bg-[#F8F9FE]"
>
    <div class="tw-flex tw-flex-shrink-0">
        <img
            [src]="esgData?.desktopcard_url"
            class="tw-rounded-[15px] lg:tw-w-[382px] md:tw-w-[230px] lg:tw-h-[383px] tw-w-full tw-h-[250px] md:tw-h-full tw-object-cover xl:tw-block tw-hidden"
        />
        <img
            [src]="esgData?.portraitcard_url || esgData?.desktopcard_url"
            class="tw-rounded-[15px] lg:tw-w-[382px] md:tw-w-[230px] lg:tw-h-[383px] tw-w-full tw-h-[250px] md:tw-h-full tw-object-cover xl:tw-hidden md:tw-block tw-hidden"
        />
        <img
            [src]="esgData?.mobilecard_url || esgData?.desktopcard_url"
            class="tw-rounded-[15px] lg:tw-w-[382px] md:tw-w-[230px] lg:tw-h-[383px] tw-w-full tw-h-[250px] md:tw-h-full tw-object-cover md:tw-hidden tw-block"
        />
    </div>
    <div
        class="tw-flex tw-flex-col lg:tw-gap-[35px] md:tw-gap-[30px] tw-gap-[25px] tw-justify-center"
    >
        <div class="tw-flex tw-flex-col tw-gap-[10px] tw-text-left">
            <span
                class="tw-text-[22px] md:tw-text-[20px] lg:tw-text-[28px] tw-font-bold tw-text-[#024B3F]"
                >{{ esgData?.title }}</span
            >
            <span
                class="tw-text-[14px] tw-font-normal tw-text-[#1A202C] tw-leading-[22px] default-html"
                [innerHTML]="esgData?.description"
            ></span>
        </div>
        <div
            class="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-[20px] md:tw-gap-[31px]"
        >
            <div
                class="tw-flex tw-flex-row md:tw-flex-col tw-gap-[15px] lg:tw-gap-[16px] md:tw-gap-[10px] tw-items-center"
            >
                <img
                    [src]="cardsData?.icon1_url"
                    alt="Environmental Image"
                    class="tw-w-[60px] tw-h-[60px] lg:tw-w-[76px] lg:tw-h-[76px] md:tw-w-[50px] md:tw-h-[50px] tw-flex-shrink-0"
                />
                <div
                    class="tw-flex tw-flex-col tw-gap-[5px] md:tw-items-center"
                >
                    <span
                        class="tw-text-[16px] lg:tw-text-[16px] md:tw-text-[14px] tw-font-bold md:tw-text-center"
                        >{{ cardsData?.title1 }}</span
                    >
                    <span
                        class="tw-text-[14px] tw-font-semibold tw-text-left md:tw-text-center default-html"
                        [innerHTML]="cardsData?.description1"
                    ></span>
                </div>
            </div>
            <div
                class="tw-flex tw-flex-row md:tw-flex-col tw-gap-[15px] lg:tw-gap-[16px] md:tw-gap-[10px] tw-items-center"
            >
                <img
                    [src]="cardsData?.icon2_url"
                    alt="Social Image"
                    class="tw-w-[60px] tw-h-[60px] lg:tw-w-[76px] lg:tw-h-[76px] md:tw-w-[50px] md:tw-h-[50px] tw-flex-shrink-0"
                />
                <div
                    class="tw-flex tw-flex-col tw-gap-[5px] md:tw-items-center"
                >
                    <span
                        class="tw-text-[16px] lg:tw-text-[16px] md:tw-text-[14px] tw-font-bold md:tw-text-center"
                        >{{ cardsData?.title2 }}</span
                    >
                    <span
                        class="tw-text-[14px] tw-font-semibold tw-text-left md:tw-text-center default-html"
                        [innerHTML]="cardsData?.description2"
                    ></span>
                </div>
            </div>
            <div
                class="tw-flex tw-flex-row md:tw-flex-col tw-gap-[15px] lg:tw-gap-[16px] md:tw-gap-[10px] tw-items-center"
            >
                <img
                    [src]="cardsData?.icon3_url"
                    alt="Governance Image"
                    class="tw-w-[60px] tw-h-[60px] lg:tw-w-[76px] lg:tw-h-[76px] md:tw-w-[50px] md:tw-h-[50px] tw-flex-shrink-0"
                />
                <div
                    class="tw-flex tw-flex-col tw-gap-[5px] md:tw-items-center"
                >
                    <span
                        class="tw-text-[16px] lg:tw-text-[16px] md:tw-text-[14px] tw-font-bold md:tw-text-center"
                        >{{ cardsData?.title3 }}</span
                    >
                    <span
                        class="tw-text-[14px] tw-font-semibold tw-text-left md:tw-text-center default-html"
                        [innerHTML]="cardsData?.description3"
                    ></span>
                </div>
            </div>
        </div>
    </div>
</div>
